// extracted by mini-css-extract-plugin
export default {"buttonGroup":"ButtonGroup_buttonGroup__kF6st","stretch":"ButtonGroup_stretch__7yDLf","connected":"ButtonGroup_connected__F+OLs"};